export default {
  cardholder_name: 'Full name',
  cardholder_name_placeholder: 'Name on card',
  card_number: 'Card number',
  card_number_placeholder: '1234 5678 9012 3456',
  expiry: 'Expiration date',
  expiry_placeholder: 'MM / YY',
  cvv: 'Security code',
  cvv_label: 'Security code (CVC)',
  cvv_placeholder: 'CVC',
  loading: 'Initializing secure card form…',
  sdk_load_failed: "The secure card form couldn't load. Check your connection and refresh the page.",
  errors: {
    number_blank: 'Enter your card number.',
    number_invalid: "This card number isn't valid. Check the digits and try again.",
    number_incomplete: 'Your card number is incomplete.',
    cvv_blank: 'Enter the security code on the back of your card.',
    cvv_invalid: "This security code isn't valid. Check the 3 or 4 digits on your card.",
    cvv_incomplete: 'Enter all {{count}} digits of your security code.',
    expiry_invalid: 'Enter a valid expiration date as MM / YY.',
    expired: 'This card has expired. Please use another card.',
    name_blank: 'Enter the name exactly as it appears on your card.',
    configuration: "Card payments aren't available right now. Please try another payment method.",
    generic: "We couldn't check your card details. Please try again.",
  },
};
